import React, { useState, useEffect } from 'react';
import { Copy, Clock } from 'lucide-react';

const Hero: React.FC = () => {
  const [timestamp, setTimestamp] = useState<number>(Math.floor(Date.now() / 1000));
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimestamp(Math.floor(Date.now() / 1000));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const handleCopy = () => {
    navigator.clipboard.writeText(timestamp.toString());
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="relative w-full bg-slate-900 overflow-hidden border-b border-slate-800">
      {/* Animated Blobs */}
      <div className="blob w-64 h-64 bg-sky-600 rounded-full top-[-50px] left-[-50px] mix-blend-screen opacity-20 animate-pulse"></div>
      <div className="blob w-72 h-72 bg-indigo-600 rounded-full bottom-[-50px] right-[-50px] mix-blend-screen opacity-20" style={{ animationDelay: '2s' }}></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 py-12 sm:px-6 lg:px-8 text-center">
        {/* Not an <h1>: each route owns its own heading, so this stays a label. */}
        <p className="text-slate-400 text-sm font-semibold uppercase tracking-wider mb-2 flex items-center justify-center gap-2">
          <Clock size={16} /> Current Unix Epoch
        </p>
        <div className="flex flex-col items-center justify-center">
          <div 
            className="text-6xl md:text-8xl font-mono font-bold text-white tracking-tight cursor-pointer hover:text-sky-400 transition-colors duration-200 select-all"
            onClick={handleCopy}
            title="Click to copy"
          >
            {timestamp}
          </div>
          <button
            onClick={handleCopy}
            className="mt-4 flex items-center gap-2 px-4 py-2 rounded-full bg-slate-800 text-slate-300 hover:bg-slate-700 hover:text-white transition-all text-sm font-medium border border-slate-700"
          >
            <Copy size={14} />
            {copied ? 'Copied!' : 'Click to Copy'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Hero;